import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Button, Box, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export default function PagoResultado() {
  const [status, setStatus] = useState('');
  const [monto, setMonto] = useState('');
  const [referencia, setReferencia] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Leer parámetros de la URL
    const params = new URLSearchParams(window.location.search);
    setStatus(params.get('x_response') || params.get('status') || 'pendiente');
    setMonto(params.get('x_amount') || params.get('monto') || '');
    setReferencia(params.get('x_ref_payco') || params.get('referencia') || '');
  }, []);

  const getConfig = () => {
    switch (status?.toLowerCase()) {
      case 'aceptada':
        return { icon: <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main' }} />, title: '¡Pago Exitoso!', color: 'success.main', msg: 'Tu suscripción ha sido activada. Ya puedes usar Smart Track.' };
      case 'rechazada':
        return { icon: <CancelIcon sx={{ fontSize: 80, color: 'error.main' }} />, title: 'Pago Rechazado', color: 'error.main', msg: 'Tu pago fue rechazado. Por favor intenta con otra tarjeta.' };
      case 'pendiente':
        return { icon: <AccessTimeIcon sx={{ fontSize: 80, color: 'warning.main' }} />, title: 'Pago Pendiente', color: 'warning.main', msg: 'Tu pago está siendo procesado. Te notificaremos cuando se confirme.' };
      default:
        return { icon: <CircularProgress size={80} />, title: 'Procesando...', color: 'primary.main', msg: 'Verificando el estado de tu pago.' };
    }
  };

  const config = getConfig();

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>{config.icon}</Box>
        <Typography variant="h4" fontWeight="bold" color={config.color} gutterBottom>
          {config.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {config.msg}
        </Typography>
        {monto && (
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
            Monto: ${monto} USD
          </Typography>
        )}
        {referencia && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Referencia: {referencia}
          </Typography>
        )}
        <Button variant="contained" onClick={() => navigate('/suscripcion')} sx={{ mr: 1 }}>
          Ver Suscripción
        </Button>
        <Button variant="outlined" onClick={() => navigate('/')}>
          Ir al Dashboard
        </Button>
      </Paper>
    </Container>
  );
}